import React from 'react';

interface EmptyStateProps {
  title?: string;
  description?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'Nothing to show yet',
  description = 'There is no data available for this section.',
}) => (
  <div className="flex flex-col items-center justify-center py-8 text-center text-md text-muted">
    <div className="mb-2 h-10 w-10 rounded-full bg-[var(--color-gray-100)]" />
    <p className="font-medium text-[var(--color-gray-800)]">{title}</p>
    <p className="mt-1 max-w-sm text-sm text-muted">{description}</p>
  </div>
);

export default EmptyState;

